import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const CosmeticsContext = createContext({});

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CosmeticsProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [equipped, setEquipped] = useState({});
  const [equippedDetails, setEquippedDetails] = useState({});

  const fetchEquipped = useCallback(async () => {
    if (!token) {
      setEquipped({});
      setEquippedDetails({});
      return;
    }
    try {
      const res = await fetch(`${API_URL}/api/cosmetics/inventory`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        // equipped contains full item objects (not just IDs)
        const eq = data.equipped || {};
        setEquipped(eq);
        setEquippedDetails(eq);
      }
    } catch (err) {
      console.error('Failed to fetch cosmetics:', err);
    }
  }, [token]);

  useEffect(() => {
    if (user) fetchEquipped();
    else { setEquipped({}); setEquippedDetails({}); }
  }, [user, fetchEquipped]);

  // Get the theme artwork URL or null
  const themeImage = equippedDetails?.theme?.preview_data?.image_url || null;
  const themeColors = equippedDetails?.theme?.preview_data || null;
  const badgeDetail = equippedDetails?.badge || null;
  const cardStyleDetail = equippedDetails?.card_style || null;
  const frameDetail = equippedDetails?.avatar_frame || null;

  return (
    <CosmeticsContext.Provider value={{
      equipped,
      equippedDetails,
      themeImage,
      themeColors,
      badgeDetail,
      cardStyleDetail,
      frameDetail,
      refreshCosmetics: fetchEquipped,
    }}>
      {children}
    </CosmeticsContext.Provider>
  );
};

export const useCosmetics = () => useContext(CosmeticsContext);
